import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
// import Moment from "moment";
// import { Flex } from "@100mslive/roomkit-react";
import FullPageProgress from "../../FullPageProgress";
import PostEditorView from "../../Post/Editor/PostEditorView";
import PostPreviewAnalytics from "../../Post/Preview/PostPreviewAnalytics";
import PostPreviewAuthor from "../../Post/Preview/PostPreviewAuthor";
import PostPreviewStatic from "../../Post/Preview/PostPreviewStatic";
import PostPreviewTitle from "../../Post/Preview/PostPreviewTitle";
import { ToastManager } from "../../Toast/ToastManager";
import { SESSION_AUTH } from "../../../common/auth";
import { GET_READ_TIME, GET_TEXT_HTML } from "../../../common/utils";
import { COMPANY_SERVICES } from "../../../services";

const CompanyPostView = props => {
  const { postId, orgId, onClose } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [dataFetched, setDataFetched] = useState(false);
  const [postDetail, setPostDetail] = useState("");
  const [readTime, setReadTime] = useState("");

  useEffect(() => {
    if (isUserSession) {
      setUserData(isUserSession);
    } else {
      setUserData("");
      return navigate("/");
    }
    return () => null;
  }, [isUserSession, navigate]);

  useEffect(() => {
    if (!userData || dataFetched) return;
    let parma = {
      accountId: orgId,
      id: postId,
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
    };

    COMPANY_SERVICES.postsView(parma)
      .then(data => {
        if (data.code === 200) {
          let summary = GET_TEXT_HTML(data?.data?.postBody);
          let rTime = GET_READ_TIME(summary);
          setReadTime(rTime);
          setPostDetail(data?.data);
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
          onClose();
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
        onClose();
      });

    setDataFetched(true);
  }, [
    userData,
    dataFetched,
    postId,
    orgId,
    isUserSession,
    LOGOUT_USER_SESSION,
    onClose,
  ]);

  return postDetail ? (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog"
      fullWidth={true}
      maxWidth="md"
      PaperProps={{
        sx: {
          width: "100%",
        },
      }}
    >
      <DialogContent>
        <PostPreviewTitle postTitle={postDetail?.postTitle} />
        <PostPreviewStatic
          postTime={postDetail?.publishedAt}
          readTime={readTime}
          category={postDetail?.category}
          status={postDetail?.status}
        />
        <PostPreviewAuthor author={postDetail?.author} />
        <PostPreviewAnalytics {...postDetail} />
        <div className="com-divider w-100"></div>
        {postDetail?.postBody ? (
          <PostEditorView content={postDetail?.postBody} />
        ) : null}
      </DialogContent>

      <DialogActions className="custom-dialog-action text-center">
        <Button
          variant="outlined"
          color="secondary"
          className="events6ix-btn events6ix-btn-light"
          type="button"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    <FullPageProgress zindex={999999999} fixed={true} />
  );
};

export default CompanyPostView;
